import React from 'react'
import { Drawer, Typography } from 'antd'
import { CompanyDetails } from './CompanyDetails'
import { SupplierOrderList } from './SupplierOrderList'
import { CompletedPurchaseOrderList } from './CompletedPurchaseOrderList'
import { LineItem, Material, Status } from '../../types/ffe'

const { Title } = Typography

export type DraftPurchaseOrderMaterial = Material & {
  quantity: number
  status: Status
  materialId: string
  lineItem: LineItem
}

export type SupplierOrderItemList = Array<
  | (LineItem & { type: 'lineItem'; selected: boolean })
  | (DraftPurchaseOrderMaterial & { type: 'material'; selected: boolean })
>

export const PurchaseOrderDrawer: React.FC<{
  open: boolean
  onClose: () => void
}> = ({ open, onClose }) => {
  return (
    <Drawer
      title="Purchase Orders"
      placement="right"
      width={800}
      open={open}
      onClose={onClose}
    >
      {open && (
        <div className="space-y-6">
          <CompanyDetails />

          <Title level={5} className="!mt-8">
            Items to be Ordered
          </Title>
          <SupplierOrderList />

          <Title level={5} className="!mt-8">
            Past Orders
          </Title>
          <CompletedPurchaseOrderList />
        </div>
      )}
    </Drawer>
  )
}
